import React, { Component } from 'react';
import PropTypes from 'prop-types';
// Local Deps
import './SearchInputGroup.scss';
import NFButton from '../../../primitives/NFButton';
import NFInputGroup from '../../../FormBuilder/NFInputGroup/NFInputGroup';

export default class SearchInputGroup extends Component {
  static propTypes = {
    onSearchButtonClick: PropTypes.func.isRequired,
    onSearchInputKeyDown: PropTypes.func.isRequired,
    onSearchInputChange: PropTypes.func.isRequired,
    searchText: PropTypes.string,
  };

  static defaultProps = {
    searchText: '',
  };

  static _generateAddOn() {
    return (
      <NFButton className="nf-button--orange">
        <i className="fa fa-search" />
      </NFButton>
    );
  }

  render() {
    const {
      onSearchButtonClick,
      onSearchInputKeyDown,
      onSearchInputChange,
      searchText,
    } = this.props;

    const addon = SearchInputGroup._generateAddOn();

    return (
      <div className="nf-search-input-group">
        <NFInputGroup
          addon={addon}
          onAddonClick={onSearchButtonClick}
          onKeyDown={onSearchInputKeyDown}
          onChange={onSearchInputChange}
          text={searchText}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SolicitationsSearchBar/subComponents/SearchInputGroup/SearchInputGroup.jsx